import Component from 'inferno-component';
import { connect } from 'inferno-redux';
import { Link } from 'inferno-router';
import EmailSentIcon from '../assets/images/email-sent-icon';
import Page from '../components/Page';
import { emailResetPasswordCode } from '../redux/auth';

function mapStateToProps(state) {
  return state;
}

class ForgotPassword extends Component {
  constructor(props) {
    super(props);

    this.state = {
      resetCodeSent: false,
      error: null,
      userEmail: null,
    };
  }

  sendResetCode = e => {
    e.preventDefault();

    const email = e.target.email.value;

    return this.props
      .emailResetPasswordCode(email)
      .then(({ data, resendEmail }) => {
        this.setState({ resetCodeSent: true, userEmail: email, resendEmail });
      })
      .catch(err => {
        let message;
        switch (err.code) {
          case 'InvalidParameterException':
            if (/already confirmed/i.test(err.message)) {
              message = 'Please verify your email before resetting your password';
              break;
            }
          case 'UserNotFoundException':
            message = 'Please check that the provided email is correct';
            break;
          default:
            message = err.message
        }
        this.setState({ error: message });
      });
  };

  renderBody = () => {
    const { resetCodeSent, userEmail, error, resendEmail } = this.state;
    if (resetCodeSent) {
      return (
        <div className="forgot-password__form">
          <div className="forgot-password__sent-message">
            <EmailSentIcon className="forgot-password__sent-icon" />
            {resendEmail ? (
              <p className="forgot-password__sent-text">
                Your account has not yet been confirmed. A confirmation email to
                verify your account has been sent to
              </p>
            ) : (
              <p className="forgot-password__sent-text">
                An email with a password reset code has been sent to
              </p>
            )}
          </div>
          <span className="forgot-password__sent-email">{userEmail}</span>
        </div>
      );
    }
    return (
      <div className="forgot-password__form">
        <p className="forgot-password__instructions">
          We’ll send a code for you to reset your password to the email below
        </p>
        <form onsubmit={this.sendResetCode}>
          <label className="form__field">
            <span className="form__label-text">Email Address</span>
            <input className="form__input" name="email" type="text" />
            {error && <div className="form__error">{error}</div>}
          </label>
          <button className="button button--form" type="submit">
            Reset My Password
          </button>
        </form>
        <Link className="link" to="/login">
          &larr; Back To Login
        </Link>
      </div>
    );
  };

  render() {
    return (
      <Page>
        <div>
          <h1 className="section__title">Forgot Your Password?</h1>
          {this.renderBody()}
        </div>
      </Page>
    );
  }
}

export default connect(mapStateToProps, { emailResetPasswordCode })(
  ForgotPassword
);



// WEBPACK FOOTER //
// ./src/pages/ForgotPassword.js